import { render, staticRenderFns } from "./Remaining.vue?vue&type=template&id=54e312b3&scoped=true&"
import script from "./Remaining.vue?vue&type=script&lang=js&"
export * from "./Remaining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e312b3",
  null
  
)

export default component.exports